import React, { Component } from 'react';
import anime from 'animejs';
import './Loading.css';

class Loading extends Component {
  constructor(props){
    super(props);
    this.state = {
      isLoaded: props.isDatLoaded
    }
    this.fadeOut = this.fadeOut.bind(this);
  }

  componentDidMount(){

  }
  fadeOut(){
    anime({
      targets: '.loading-progress, .loading-progress-text',
      opacity: 0,
      delay:function(el,index){
        return 200 * index;
      },
      duration: 400,
      easing: 'easeInExpo'
    });
  }
  render() {
    const circleRadius = 48;
    const circleR = 2 * Math.PI * circleRadius;
    const NowProgress = circleR * (1 - this.props.loadedNum/this.props.total);
    if(this.props.loadedNum/this.props.total === 1){
      this.fadeOut();

    }
    return (
      <div className={this.props.isDatLoaded ? "loading hidden" : "loading"}>
        <div className="loading-progress">
          <svg width="64" height="64" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r={circleRadius} fill="none" stroke="#000"  strokeWidth="12"/>
            <circle cx="60" cy="60" r={circleRadius} fill="none" stroke="#069AFF" strokeWidth="8" strokeDasharray={circleR}
              strokeDashoffset={NowProgress ? NowProgress : 0} />
            <text textAnchor="middle" transform="rotate(90,60,60)" fill="#069AFF" x="60" y="50">{this.props.loadedNum/this.props.total === 1 ? '': 'loading'}</text>
            <text fontSize="22px" transform="rotate(90,60,60)" textAnchor="middle" fill="#069AFF" x="60" y="80">{this.props.loadedNum/this.props.total === 1 ? '': this.props.loadedNum}</text>
          </svg>
        </div>
        <p className="loading-progress-text">{this.props.loadedNum/this.props.total === 1 ? 'Complete!!': 'Data loading...'}</p>
      </div>
    );
  }
}
export default Loading;



// WEBPACK FOOTER //
// ./src/Loading.js